import { PaymentTypes } from './payment.model';

export enum CashierConfigurationKeys {
  UserId = 'userId',
  SessionId = 'sessionId',
  MerchantId = 'merchantId',
  PaymentType = 'paymentType',
  PaymentMethod = 'paymentMethod',
  Currency = 'currency',
  Bonus = 'bonus',
  TermsUrl = 'termsUrl',
  Platform = 'platform',
  Host = 'host',
  Language = 'language',
  CustomerBalance = 'customerBalance',
  WebView = 'webView',
  Direction = 'direction',
  Country = 'country',
  OrderId = 'orderId',
  Amount = 'amount',
  InitialAmount = 'initialAmount',
  Window = 'window',
  Theme = 'theme',
  SubmitInitiator = 'submitInitiator',
  ApiVersion = 'apiVersions', //@TODO: will be unnecessary after PGW-3023 deploy to PROD
  UiVersion = 'uiVersion',
}

export interface FlexibleCashierConfiguration {
  userId: string | null;
  sessionId: string | null;
  merchantId: string | null;
  paymentType: PaymentTypes | null;
  currency: string | null;
  bonus: string | null;
  termsUrl: string | null;
  platform: string | null;
  host: string | null;
  language: string | null;
  location: string;
  customerBalance: string | null;
  webView: boolean;
  direction: Directions;
  country: string | null;
  orderId: string | null;
  initialAmount: string | null;
  amount: string | null;
  theme: ColourThemes;
  submitInitiator: SubmitInitiators;
  apiVersion: ApiVersions;
  uiVersion: UiVersions;
}

export interface PermanentCashierConfiguration {
  notifyCustomerAboutPaymentResult: boolean;
  version: Versions;
  cashierFieldUrl: string;
}

export type CashierConfiguration = PermanentCashierConfiguration &
  FlexibleCashierConfiguration;

export enum WindowNames {
  /*@TODO: make sure, is "PROVIDER_"-prefix required or not*/
  Iframe = 'PROVIDER_IFRAME',
  Window = 'PROVIDER_WINDOW',
}

export enum ApiVersions {
  v1 = 'v1',
  v2 = 'v2',
}

export enum UiVersions {
  v1 = 'v1',
  v2 = 'v2',
}

export enum Versions {
  v2 = 'v2',
  v3 = 'v3',
  v4 = 'v4',
}

export enum ColourThemes {
  Light = 'light',
  Dark = 'dark',
}

export enum Directions {
  Ltr = 'ltr',
  Rtl = 'rtl',
}

export enum SubmitInitiators {
  Self = 'self',
  Parent = 'parent',
}

export enum IntegrationThemes {
  Default = 'Default',
  Platform = 'Platform',
}

export enum DynamicScreens {
  FinalScreen = 'FinalScreen',
  ProcessingResult = 'ProcessingResult',
  PaymentForm = 'PaymentForm',
  ConfirmationForm = 'ConfirmationForm',
}
